module.exports = __webpack_public_path__ + "img/print.9b76be9.webp";